import { Observable } from "rxjs";
import { PlanType } from "../domain/models/plan-type";

export abstract class PlanTypeRepository {
    abstract getPlanTypes(): Observable<PlanType[]>;
}